import MultiTabComponent from "@/manager/components/multi-tab-component/multi-tab-component";
import Page from "@/manager/components/page/page";
import "./tenant-template-list.scss";
import TenantTemplateTab from "./tabs/tenant-template-tab";

const TenantTemplateList = () => {
  return (
    <Page title={{ text: "Model Report Templates" }}>
      <div className="tenantTemplateList">
        <div className="tenantTemplateList-tabs">
          <MultiTabComponent
            displayNextButton={false}
            tabs={[
              {
                key: "analytics_report_template",
                name: "Report Templates",
                content: <TenantTemplateTab templateType="analytics_report_template" />,
              },
              {
                key: "analytics_report_pdf_template",
                name: "PDF Templates",
                content: <TenantTemplateTab templateType="analytics_report_pdf_template" />,
              },
            ]}
          />
        </div>
      </div>
    </Page>
  );
};

export default TenantTemplateList;